// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"3220ed8c","247":"55973584","627":"e17c718f","653":"7c3048a8","834":"931bed95","867":"7a7e8953","923":"39b90ea9","938":"330e9c56"}[chunkId] + ".chunk.js";
};